/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import LanguageDetector from 'i18next-browser-languagedetector';
import en from './en.json';
import fi from './fi.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// get language from app container if it exists
const root = document.getElementById('indigo-selector') as HTMLElement
const lang = root?.getAttribute('data-lang')
let storedLanguage = "";
if (lang) {
  storedLanguage = localStorage.getItem('i18nextLng')?.substring(0,2) ?? lang;
} else {
  storedLanguage = localStorage.getItem('i18nextLng')?.substring(0,2) ?? 'en';
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'en',
    lng: ['en', 'fi'].includes(storedLanguage) ? storedLanguage : 'en',
    resources: {
      en,
      fi,
    },
    interpolation: {
      escapeValue: false,
    },
    ns: ['common'],
    defaultNS: 'common',
  });

export default i18n;
